import { ResponsiveImage } from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryClients = graphql(
  /* GraphQL */ `
    query Clients($first: IntType = 100, $skip: IntType) {
      _allClientsMeta {
        count
      }
      allClients(first: $first, skip: $skip) {
        __typename
        _modelApiKey
        id
        logo {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 260 }
          ) {
            ...ResponsiveImage
          }
        }
        textureDark {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 260 }
          ) {
            ...ResponsiveImage
          }
        }
        textureLight {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 260 }
          ) {
            ...ResponsiveImage
          }
        }
        name
        slug
      }
    }
  `,
  [ResponsiveImage]
)
